import { KEY_LABEL_REPLY_TYPE_AS, KEY_LABEL_REPLY_TYPE_CS, KEY_LABEL_REPLY_TYPE_HKR, KEY_LABEL_REPLY_TYPE_OSR, KEY_LABEL_REPLY_TYPE_SO, KEY_LABEL_REPLY_TYPE_VA, KEY_LABEL_REPLY_TYPE_VO, MODULE_REPLY_SELECTION } from "config/const/locale"

export const sug_data = [
    {
        id: 1,
        label: KEY_LABEL_REPLY_TYPE_HKR,
        value: 'hongkong_company_registration'
    },
    {
        id: 2,
        label: KEY_LABEL_REPLY_TYPE_OSR,
        value: 'overseas_company_registration'
    },
    {
        id: 3,
        label: KEY_LABEL_REPLY_TYPE_AS,
        value: 'accounting_service'
    },
    {
        id: 4,
        label: KEY_LABEL_REPLY_TYPE_CS,
        value: 'company_secretary'
    },
    {
        id: 5,
        label: KEY_LABEL_REPLY_TYPE_SO,
        value: 'serviced_office'
    },
    {
        id: 6,
        label: KEY_LABEL_REPLY_TYPE_VO,
        value: 'virtual_office'
    },
    {
        id: 7,
        label: KEY_LABEL_REPLY_TYPE_VA,
        value: 'value_added_service'
    },
]
